import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/fashionable-canes-shopify-seo-case-study.es.md?raw";

const PATH = "/es/recursos/caso-fashionable-canes-seo";
const ALT = "/resources/fashionable-canes-seo-case-study";
const TITLE = "Fashionable Canes: 15.000+ SKUs, migración de theme Shopify y recuperación SEO";
const META_TITLE = "Caso Fashionable Canes: Shopify y SEO · Shugert";
const DESCRIPTION = "Cómo Fashionable Canes migró un theme con 15.000+ SKUs, recuperó rankings en 60 días y registró +180% de tráfico orgánico y +350% de ROI.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Perfil de Shugert Marketing", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Fashionable Canes", publisher: "Fashionable Canes", href: "https://fashionablecanes.com/" },
  { label: "Resultados publicados del proyecto", publisher: "Shugert", href: "https://shugert.com.mx/work" },
  { label: "Documentación SEO", publisher: "Google Search Central", href: "https://developers.google.com/search/docs" },
];

const RELATED = [
  { label: "Caso Llantas Cavazos", href: "/es/recursos/caso-llantas-cavazos-migracion" },
  { label: "SEO técnico para Shopify", href: "/es/seo-tecnico-shopify" },
  { label: "Rendimiento Shopify", href: "/es/rendimiento" },
  { label: "Todos los casos Shopify", href: "/es/proyectos" },
];

export const Route = createFileRoute("/es/recursos/caso-fashionable-canes-seo")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Caso Shopify SEO", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Caso Shopify SEO" }),
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }, { name: "Caso Fashionable Canes", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="es" path={PATH} title={TITLE}
        excerpt="Cómo un retailer Shopify consolidado modernizó un storefront de 15.000+ SKUs protegiendo demanda orgánica, recuperando rankings en 60 días y registrando mejoras materiales de tráfico y ROI."
        body={body} updated="Agosto de 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={11}
        focus="Cómo se coordinaron migración de theme, recuperación de SEO técnico, structured data, crawlability y ownership de intención comercial en un catálogo grande y activo."
        audience="Marcas Shopify establecidas que preparan una migración de theme o recuperación SEO y para las que una regresión en tráfico orgánico tendría coste comercial real."
        sources={SOURCES} related={RELATED}
        category="Caso de SEO y migración de theme Shopify" backLabel="← Proyectos" backHref="/es/proyectos"
        cta={{ eyebrow: "SEO para catálogos grandes", title: "Protege la demanda orgánica antes de cambiar de theme.", body: "Definimos riesgos técnicos, templates, catálogo, performance y lanzamiento antes de modificar el storefront para que la migración tenga criterios comerciales medibles.", label: "Solicitar alcance técnico", href: "/es/cotizacion?intent=seo&source=fashionable-canes-case-study" }}
      />
    </SiteShell>
  ),
});
